export const normalizedLanguage = (language?: string) => {
  if (!language) return 'en';
  const normalized = language.trim().toLowerCase();
  if (normalized.startsWith('zh') || normalized.includes('chinese')) {
    return 'zh';
  }
  if (normalized.startsWith('en') || normalized.includes('english')) {
    return 'en';
  }
  return 'en';
};
